<template>
    <a class="mr-24 button-dashboard" href="/">
        <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="MVP" stroke="none" stroke-width="1" fill-rule="evenodd">
                <g id="Edit---listing-address" transform="translate(-24.000000, -16.000000)">
                    <g id="Top-nav-/-dash">
                        <path d="M26.6407767,16 L53.3592233,16 C54.817684,16 56,17.182316 56,18.6407767 L56,45.3592233 C56,46.817684 54.817684,48 53.3592233,48 L26.6407767,48 C25.182316,48 24,46.817684 24,45.3592233 L24,18.6407767 C24,17.182316 25.182316,16 26.6407767,16 Z M30.1359223,38.904233 L30.1359223,41.4483883 L35.096233,39.598835 L35.096233,24.8749515 L47.568699,24.8749515 L47.568699,28.8038058 L37.4418641,32.5940971 L37.4418641,35.1074175 L49.9194563,30.4406214 L49.9194563,22.5242718 L32.7456311,22.5242718 L32.7456311,37.9283107 L30.1359223,38.904233 Z" id="Combined-Shape"></path>
                    </g>
                </g>
            </g>
        </svg>
        <span class="subtitle">Dashboard</span>
    </a>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>
